module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uci1jW/tc-custom/9781595554123.jpg?1705238410816",
      "alt": "This image is the cover for the book Sherman, The Generals Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sherman, The Generals Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An overview of the life of the controversial Union Civil War general, William Tecumseh Sherman.")]), _c('br'), _c('br'), _vm._v("He was named after an enemy of the United States. "), _c('br'), _c('br'), _vm._v("He was proslavery despite his loyalty to the Union. He burned and pillaged an already beaten foe on a march history will never forget."), _c('br'), _c('br'), _vm._v("If, as he famously said, “war is hell,” William Tecumsah Sherman can be classified as a flamethrower of ruthless ferocity. Defined by his contradictions, Sherman achieved immortality in his role as Ulysses Grant’s hammer in the Civil War. A failed banker and lawyer, Sherman found his calling with the outbreak of war in 1861. With indecision a common ailment among Union generals early the conflict, Sherman’s temperament and unwavering focus on the mission at hand—preserving the Union—helped shift the fortunes of North and South."), _c('br'), _c('br'), _vm._v("Authors Agostino Von Hassell and Ed Breslin present Sherman as once man and phenomenon. From Bull Run to Shiloh, from Vicksburg to Chattanooga, and from Atlanta to Savannah, Sherman carved the Confederacy with a feral singularity of purpose. At times disheveled and informal to a fault, “Uncle Billy” became a hero whose legend only grew with allegations of villainy.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Agostino von Hassell, Ed Breslin, Stephen Mansfield\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0